type dobDialogText = {
  heading: string
  subheading: string
  placeholder: string
  button: string
  error_message: string[]
}

type dobConfig = {
  name: string
  code: string
  dobDialogText: dobDialogText
}

export const DOB_DIALOG_LANGUAGES: dobConfig[] = [
  {
    name: 'English',
    code: 'en-US',
    dobDialogText: {
      heading: 'Verify Your Identity',
      subheading: 'Please enter your date of birth to continue.',
      placeholder: 'Date of Birth',
      button: 'VERIFY & CONTINUE',
      error_message: [
        'Please enter your date of birth.',
        'Too many attempts. Please try again later.',
        'Invalid date of birth. Please check and try again.',
        'Security validation failed. Please refresh and try again.',
        'Authentication failed. Please try again.',
        'Connection error. Please try again.',
      ],
    },
  },
  {
    name: 'Español',
    code: 'es-US',
    dobDialogText: {
      heading: 'Verifica tu identidad',
      subheading: 'Por favor, ingresa tu fecha de nacimiento para continuar.',
      placeholder: 'Fecha de nacimiento',
      button: 'VERIFICAR Y CONTINUAR',
      error_message: [
        'Por favor, ingresa tu fecha de nacimiento.',
        'Demasiados intentos. Inténtalo de nuevo más tarde.',
        'Fecha de nacimiento no válida. Verifica e inténtalo de nuevo.',
        'Error en la validación de seguridad. Actualiza e inténtalo de nuevo.',
        'Error de autenticación. Inténtalo de nuevo.',
        'Error de conexión. Inténtalo de nuevo.',
      ],
    },
  },
  {
    name: 'Deutsch',
    code: 'de-DE',
    dobDialogText: {
      heading: 'Bestätige deine Identität',
      subheading: 'Bitte gib dein Geburtsdatum ein, um fortzufahren.',
      placeholder: 'Geburtsdatum',
      button: 'BESTÄTIGEN & FORTFAHREN',
      error_message: [
        'Bitte gib dein Geburtsdatum ein.',
        'Zu viele Versuche. Bitte versuche es später erneut.',
        'Ungültiges Geburtsdatum. Bitte überprüfe es und versuche es erneut.',
        'Sicherheitsüberprüfung fehlgeschlagen. Bitte aktualisiere und versuche es erneut.',
        'Authentifizierung fehlgeschlagen. Bitte versuche es erneut.',
        'Verbindungsfehler. Bitte versuche es erneut.',
      ],
    },
  },
  {
    name: 'Français',
    code: 'fr-FR',
    dobDialogText: {
      heading: 'Vérifiez votre identité',
      subheading: 'Veuillez entrer votre date de naissance pour continuer.',
      placeholder: 'Date de naissance',
      button: 'VÉRIFIER ET CONTINUER',
      error_message: [
        'Veuillez entrer votre date de naissance.',
        'Trop de tentatives. Veuillez réessayer plus tard.',
        'Date de naissance invalide. Veuillez vérifier et réessayer.',
        'Échec de la validation de sécurité. Veuillez actualiser et réessayer.',
        'Échec de l’authentification. Veuillez réessayer.',
        'Erreur de connexion. Veuillez réessayer.',
      ],
    },
  },
  {
    name: 'हिन्दी',
    code: 'hi-IN',
    dobDialogText: {
      heading: 'अपनी पहचान सत्यापित करें',
      subheading: 'जारी रखने के लिए कृपया अपनी जन्म तिथि दर्ज करें।',
      placeholder: 'जन्म तिथि',
      button: 'सत्यापित करें और जारी रखें',
      error_message: [
        'कृपया अपनी जन्म तिथि दर्ज करें।',
        'बहुत अधिक प्रयास। कृपया बाद में पुनः प्रयास करें।',
        'अमान्य जन्म तिथि। कृपया जांचें और पुनः प्रयास करें।',
        'सुरक्षा सत्यापन विफल। कृपया पेज रीफ़्रेश करें और पुनः प्रयास करें।',
        'प्रमाणीकरण विफल। कृपया पुनः प्रयास करें।',
        'कनेक्शन त्रुटि। कृपया पुनः प्रयास करें।',
      ],
    },
  },
  {
    name: 'Português',
    code: 'pt-BR',
    dobDialogText: {
      heading: 'Verifique sua identidade',
      subheading: 'Por favor, insira sua data de nascimento para continuar.',
      placeholder: 'Data de nascimento',
      button: 'VERIFICAR E CONTINUAR',
      error_message: [
        'Por favor, insira sua data de nascimento.',
        'Muitas tentativas. Tente novamente mais tarde.',
        'Data de nascimento inválida. Verifique e tente novamente.',
        'Falha na validação de segurança. Atualize e tente novamente.',
        'Falha na autenticação. Tente novamente.',
        'Erro de conexão. Tente novamente.',
      ],
    },
  },
  {
    name: 'العربية',
    code: 'ar-XA',
    dobDialogText: {
      heading: 'تحقق من هويتك',
      subheading: 'يرجى إدخال تاريخ ميلادك للمتابعة.',
      placeholder: 'تاريخ الميلاد',
      button: 'تحقق واستمر',
      error_message: [
        'يرجى إدخال تاريخ ميلادك.',
        'محاولات كثيرة جدًا. يرجى المحاولة لاحقًا.',
        'تاريخ ميلاد غير صالح. يرجى التحقق والمحاولة مرة أخرى.',
        'فشل التحقق الأمني. يرجى التحديث والمحاولة مرة أخرى.',
        'فشل التحقق من الهوية. يرجى المحاولة مرة أخرى.',
        'خطأ في الاتصال. يرجى المحاولة مرة أخرى.',
      ],
    },
  },
  {
    name: 'Bahasa Indonesia',
    code: 'id-ID',
    dobDialogText: {
      heading: 'Verifikasi Identitas Anda',
      subheading: 'Silakan masukkan tanggal lahir Anda untuk melanjutkan.',
      placeholder: 'Tanggal lahir',
      button: 'VERIFIKASI & LANJUTKAN',
      error_message: [
        'Silakan masukkan tanggal lahir Anda.',
        'Terlalu banyak percobaan. Coba lagi nanti.',
        'Tanggal lahir tidak valid. Periksa dan coba lagi.',
        'Validasi keamanan gagal. Segarkan halaman dan coba lagi.',
        'Autentikasi gagal. Coba lagi.',
        'Kesalahan koneksi. Coba lagi.',
      ],
    },
  },
  {
    name: 'Italiano',
    code: 'it-IT',
    dobDialogText: {
      heading: 'Verifica la tua identità',
      subheading:
        'Per favore, inserisci la tua data di nascita per continuare.',
      placeholder: 'Data di nascita',
      button: 'VERIFICA E CONTINUA',
      error_message: [
        'Per favore, inserisci la tua data di nascita.',
        'Troppi tentativi. Riprova più tardi.',
        'Data di nascita non valida. Controlla e riprova.',
        'Verifica di sicurezza non riuscita. Aggiorna e riprova.',
        'Autenticazione fallita. Riprova.',
        'Errore di connessione. Riprova.',
      ],
    },
  },
  {
    name: '日本語',
    code: 'ja-JP',
    dobDialogText: {
      heading: '本人確認',
      subheading: '続行するには生年月日を入力してください。',
      placeholder: '生年月日',
      button: '確認して続行',
      error_message: [
        '生年月日を入力してください。',
        '試行回数が多すぎます。後でもう一度お試しください。',
        '無効な生年月日です。確認して再試行してください。',
        'セキュリティ検証に失敗しました。更新して再試行してください。',
        '認証に失敗しました。再試行してください。',
        '接続エラー。再試行してください。',
      ],
    },
  },
  {
    name: 'Türkçe',
    code: 'tr-TR',
    dobDialogText: {
      heading: 'Kimliğinizi Doğrulayın',
      subheading: 'Devam etmek için lütfen doğum tarihinizi girin.',
      placeholder: 'Doğum tarihi',
      button: 'DOĞRULA VE DEVAM ET',
      error_message: [
        'Lütfen doğum tarihinizi girin.',
        'Çok fazla deneme. Lütfen daha sonra tekrar deneyin.',
        'Geçersiz doğum tarihi. Kontrol edip tekrar deneyin.',
        'Güvenlik doğrulaması başarısız oldu. Lütfen yenileyip tekrar deneyin.',
        'Kimlik doğrulama başarısız. Lütfen tekrar deneyin.',
        'Bağlantı hatası. Lütfen tekrar deneyin.',
      ],
    },
  },
  {
    name: 'Tiếng Việt',
    code: 'vi-VN',
    dobDialogText: {
      heading: 'Xác minh danh tính của bạn',
      subheading: 'Vui lòng nhập ngày sinh của bạn để tiếp tục.',
      placeholder: 'Ngày sinh',
      button: 'XÁC MINH & TIẾP TỤC',
      error_message: [
        'Vui lòng nhập ngày sinh của bạn.',
        'Thử quá nhiều lần. Vui lòng thử lại sau.',
        'Ngày sinh không hợp lệ. Vui lòng kiểm tra và thử lại.',
        'Xác minh bảo mật thất bại. Làm mới và thử lại.',
        'Xác thực thất bại. Vui lòng thử lại.',
        'Lỗi kết nối. Vui lòng thử lại.',
      ],
    },
  },
  {
    name: 'বাংলা',
    code: 'bn-IN',
    dobDialogText: {
      heading: 'আপনার পরিচয় যাচাই করুন',
      subheading: 'চালিয়ে যেতে আপনার জন্ম তারিখ লিখুন।',
      placeholder: 'জন্ম তারিখ',
      button: 'যাচাই করুন ও চালিয়ে যান',
      error_message: [
        'আপনার জন্ম তারিখ লিখুন।',
        'অতিরিক্ত প্রচেষ্টা। পরে আবার চেষ্টা করুন।',
        'অবৈধ জন্ম তারিখ। যাচাই করে আবার চেষ্টা করুন।',
        'নিরাপত্তা যাচাইকরণ ব্যর্থ হয়েছে। রিফ্রেশ করে আবার চেষ্টা করুন।',
        'প্রমাণীকরণ ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
        'সংযোগ ত্রুটি। আবার চেষ্টা করুন।',
      ],
    },
  },
  {
    name: 'ગુજરાતી',
    code: 'gu-IN',
    dobDialogText: {
      heading: 'તમારી ઓળખ ચકાસો',
      subheading: 'ચાલુ રાખવા માટે કૃપા કરીને તમારી જન્મ તારીખ દાખલ કરો.',
      placeholder: 'જન્મ તારીખ',
      button: 'ચકાસો અને ચાલુ રાખો',
      error_message: [
        'કૃપા કરીને તમારી જન્મ તારીખ દાખલ કરો.',
        'ઘણા પ્રયાસો થઈ ગયા છે. કૃપા કરીને પછીથી ફરી પ્રયાસ કરો.',
        'અમાન્ય જન્મ તારીખ. તપાસો અને ફરી પ્રયાસ કરો.',
        'સુરક્ષા ચકાસણી નિષ્ફળ ગઈ. કૃપા કરીને રિફ્રેશ કરીને ફરી પ્રયાસ કરો.',
        'પ્રમાણીકરણ નિષ્ફળ ગયું. કૃપા કરીને ફરી પ્રયાસ કરો.',
        'કનેક્શન ભૂલ. કૃપા કરીને ફરી પ્રયાસ કરો.',
      ],
    },
  },
  {
    name: 'ಕನ್ನಡ',
    code: 'kn-IN',
    dobDialogText: {
      heading: 'ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಿ',
      subheading: 'ಮುಂದುವರಿಸಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಜನ್ಮದಿನಾಂಕವನ್ನು ನಮೂದಿಸಿ.',
      placeholder: 'ಜನ್ಮ ದಿನಾಂಕ',
      button: 'ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಮುಂದುವರಿಸಿ',
      error_message: [
        'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಜನ್ಮದಿನಾಂಕವನ್ನು ನಮೂದಿಸಿ.',
        'ಬಹಳಷ್ಟು ಪ್ರಯತ್ನಗಳು. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'ಅಮಾನ್ಯ ಜನ್ಮದಿನಾಂಕ. ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'ಭದ್ರತಾ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ. ಪುಟವನ್ನು ರಿಫ್ರೆಶ್ ಮಾಡಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'ದೃಢೀಕರಣ ವಿಫಲವಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'ಕನೆಕ್ಷನ್ ದೋಷ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      ],
    },
  },
  {
    name: 'മലയാളം',
    code: 'ml-IN',
    dobDialogText: {
      heading: 'നിങ്ങളുടെ തിരിച്ചറിയൽ സ്ഥിരീകരിക്കുക',
      subheading: 'തുടരാൻ നിങ്ങളുടെ ജനനതീയതി നൽകുക.',
      placeholder: 'ജനനതീയതി',
      button: 'സ്ഥിരീകരിക്കുക & തുടരുക',
      error_message: [
        'നിങ്ങളുടെ ജനനതീയതി നൽകുക.',
        'വളരെ അധികം ശ്രമങ്ങൾ. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
        'അസാധുവായ ജനനതീയതി. പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
        'സുരക്ഷാ പരിശോധന പരാജയപ്പെട്ടു. പേജ് പുതുക്കി വീണ്ടും ശ്രമിക്കുക.',
        'പ്രാമാണീകരണം പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.',
        'കണക്ഷൻ പിശക്. വീണ്ടും ശ്രമിക്കുക.',
      ],
    },
  },
  {
    name: 'मराठी',
    code: 'mr-IN',
    dobDialogText: {
      heading: 'आपली ओळख सत्यापित करा',
      subheading: 'सुरू ठेवण्यासाठी कृपया आपली जन्मतारीख प्रविष्ट करा.',
      placeholder: 'जन्मतारीख',
      button: 'सत्यापित करा आणि पुढे जा',
      error_message: [
        'कृपया आपली जन्मतारीख प्रविष्ट करा.',
        'खूप प्रयत्न झाले. कृपया नंतर पुन्हा प्रयत्न करा.',
        'अवैध जन्मतारीख. कृपया तपासा आणि पुन्हा प्रयत्न करा.',
        'सुरक्षा पडताळणी अयशस्वी झाली. कृपया रीफ्रेश करून पुन्हा प्रयत्न करा.',
        'प्रमाणीकरण अयशस्वी झाले. कृपया पुन्हा प्रयत्न करा.',
        'कनेक्शन त्रुटी. कृपया पुन्हा प्रयत्न करा.',
      ],
    },
  },
  {
    name: 'தமிழ்',
    code: 'ta-IN',
    dobDialogText: {
      heading: 'உங்கள் அடையாளத்தை சரிபார்க்கவும்',
      subheading: 'தொடர உங்கள் பிறந்த தேதியை உள்ளிடவும்.',
      placeholder: 'பிறந்த தேதி',
      button: 'சரிபார்த்து தொடரவும்',
      error_message: [
        'தயவுசெய்து உங்கள் பிறந்த தேதியை உள்ளிடவும்.',
        'அதிக முயற்சிகள். பின்னர் முயற்சிக்கவும்.',
        'தவறான பிறந்த தேதி. சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
        'பாதுகாப்பு சரிபார்ப்பு தோல்வியடைந்தது. புதுப்பித்து மீண்டும் முயற்சிக்கவும்.',
        'அங்கீகாரம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.',
        'இணைப்பு பிழை. மீண்டும் முயற்சிக்கவும்.',
      ],
    },
  },
  {
    name: 'తెలుగు',
    code: 'te-IN',
    dobDialogText: {
      heading: 'మీ గుర్తింపును ధృవీకరించండి',
      subheading: 'కొనసాగడానికి దయచేసి మీ పుట్టిన తేదీని నమోదు చేయండి.',
      placeholder: 'పుట్టిన తేదీ',
      button: 'ధృవీకరించండి మరియు కొనసాగించండి',
      error_message: [
        'దయచేసి మీ పుట్టిన తేదీని నమోదు చేయండి.',
        'చాలా ప్రయత్నాలు జరిగాయి. దయచేసి తరువాత మళ్లీ ప్రయత్నించండి.',
        'చెల్లని పుట్టిన తేదీ. తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.',
        'భద్రతా ధృవీకరణ విఫలమైంది. పేజీని రిఫ్రెష్ చేసి మళ్లీ ప్రయత్నించండి.',
        'ప్రామాణీకరణ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.',
        'కనెక్షన్ లోపం. దయచేసి మళ్లీ ప్రయత్నించండి.',
      ],
    },
  },
  {
    name: 'Nederlands',
    code: 'nl-NL',
    dobDialogText: {
      heading: 'Bevestig je identiteit',
      subheading: 'Voer je geboortedatum in om door te gaan.',
      placeholder: 'Geboortedatum',
      button: 'VERIFIËREN & DOORGAAN',
      error_message: [
        'Voer je geboortedatum in.',
        'Te veel pogingen. Probeer het later opnieuw.',
        'Ongeldige geboortedatum. Controleer en probeer opnieuw.',
        'Beveiligingscontrole mislukt. Vernieuw en probeer opnieuw.',
        'Verificatie mislukt. Probeer opnieuw.',
        'Verbindingsfout. Probeer opnieuw.',
      ],
    },
  },
  {
    name: '한국어',
    code: 'ko-KR',
    dobDialogText: {
      heading: '본인 인증',
      subheading: '계속하려면 생년월일을 입력하세요.',
      placeholder: '생년월일',
      button: '확인 및 계속',
      error_message: [
        '생년월일을 입력하세요.',
        '시도 횟수가 너무 많습니다. 나중에 다시 시도하세요.',
        '잘못된 생년월일입니다. 확인 후 다시 시도하세요.',
        '보안 검증에 실패했습니다. 새로고침 후 다시 시도하세요.',
        '인증 실패. 다시 시도하세요.',
        '연결 오류. 다시 시도하세요.',
      ],
    },
  },
  {
    name: '官话',
    code: 'cmn-CN',
    dobDialogText: {
      heading: '验证您的身份',
      subheading: '请输入您的出生日期以继续。',
      placeholder: '出生日期',
      button: '验证并继续',
      error_message: [
        '请输入您的出生日期。',
        '尝试次数过多，请稍后再试。',
        '无效的出生日期，请检查后重试。',
        '安全验证失败，请刷新后重试。',
        '身份验证失败，请重试。',
        '连接错误，请重试。',
      ],
    },
  },
  {
    name: 'Polski',
    code: 'pl-PL',
    dobDialogText: {
      heading: 'Zweryfikuj swoją tożsamość',
      subheading: 'Wprowadź swoją datę urodzenia, aby kontynuować.',
      placeholder: 'Data urodzenia',
      button: 'ZWERYFIKUJ I KONTYNUUJ',
      error_message: [
        'Wprowadź swoją datę urodzenia.',
        'Zbyt wiele prób. Spróbuj ponownie później.',
        'Nieprawidłowa data urodzenia. Sprawdź i spróbuj ponownie.',
        'Błąd weryfikacji bezpieczeństwa. Odśwież stronę i spróbuj ponownie.',
        'Błąd uwierzytelniania. Spróbuj ponownie.',
        'Błąd połączenia. Spróbuj ponownie.',
      ],
    },
  },
  {
    name: 'Русский',
    code: 'ru-RU',
    dobDialogText: {
      heading: 'Подтвердите свою личность',
      subheading: 'Пожалуйста, введите дату рождения, чтобы продолжить.',
      placeholder: 'Дата рождения',
      button: 'ПОДТВЕРДИТЬ И ПРОДОЛЖИТЬ',
      error_message: [
        'Пожалуйста, введите дату рождения.',
        'Слишком много попыток. Попробуйте позже.',
        'Недействительная дата рождения. Проверьте и попробуйте снова.',
        'Ошибка проверки безопасности. Обновите страницу и попробуйте снова.',
        'Ошибка аутентификации. Попробуйте снова.',
        'Ошибка соединения. Попробуйте снова.',
      ],
    },
  },
  {
    name: 'Kiswahili',
    code: 'sw-KE',
    dobDialogText: {
      heading: 'Thibitisha Utambulisho Wako',
      subheading: 'Tafadhali ingiza tarehe yako ya kuzaliwa ili kuendelea.',
      placeholder: 'Tarehe ya kuzaliwa',
      button: 'THIBITISHA NA ENDELEA',
      error_message: [
        'Tafadhali ingiza tarehe yako ya kuzaliwa.',
        'Jaribio nyingi sana. Tafadhali jaribu tena baadaye.',
        'Tarehe ya kuzaliwa si sahihi. Kagua na ujaribu tena.',
        'Uhakiki wa usalama umeshindikana. Tafadhali onyesha upya na ujaribu tena.',
        'Uthibitishaji umeshindikana. Tafadhali jaribu tena.',
        'Hitilafu ya muunganisho. Tafadhali jaribu tena.',
      ],
    },
  },
  {
    name: 'ไทย',
    code: 'th-TH',
    dobDialogText: {
      heading: 'ยืนยันตัวตนของคุณ',
      subheading: 'กรุณากรอกวันเกิดของคุณเพื่อดำเนินการต่อ',
      placeholder: 'วันเกิด',
      button: 'ยืนยันและดำเนินการต่อ',
      error_message: [
        'กรุณากรอกวันเกิดของคุณ',
        'พยายามมากเกินไป กรุณาลองใหม่ภายหลัง',
        'วันเกิดไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง',
        'การตรวจสอบความปลอดภัยล้มเหลว กรุณารีเฟรชและลองอีกครั้ง',
        'การยืนยันตัวตนล้มเหลว กรุณาลองอีกครั้ง',
        'ข้อผิดพลาดในการเชื่อมต่อ กรุณาลองอีกครั้ง',
      ],
    },
  },
  {
    name: 'اردو',
    code: 'ur-IN',
    dobDialogText: {
      heading: 'اپنی شناخت کی تصدیق کریں',
      subheading: 'براہ کرم جاری رکھنے کے لیے اپنی تاریخ پیدائش درج کریں۔',
      placeholder: 'تاریخ پیدائش',
      button: 'تصدیق کریں اور جاری رکھیں',
      error_message: [
        'براہ کرم اپنی تاریخ پیدائش درج کریں۔',
        'بہت زیادہ کوششیں۔ براہ کرم بعد میں دوبارہ کوشش کریں۔',
        'غلط تاریخ پیدائش۔ براہ کرم چیک کریں اور دوبارہ کوشش کریں۔',
        'سیکیورٹی تصدیق ناکام ہوگئی۔ براہ کرم ریفریش کرکے دوبارہ کوشش کریں۔',
        'تصدیق ناکام ہوگئی۔ براہ کرم دوبارہ کوشش کریں۔',
        'کنکشن کی خرابی۔ براہ کرم دوبارہ کوشش کریں۔',
      ],
    },
  },
  {
    name: 'Українська',
    code: 'uk-UA',
    dobDialogText: {
      heading: 'Підтвердьте свою особу',
      subheading: 'Будь ласка, введіть дату народження, щоб продовжити.',
      placeholder: 'Дата народження',
      button: 'ПІДТВЕРДИТИ І ПРОДОВЖИТИ',
      error_message: [
        'Будь ласка, введіть дату народження.',
        'Забагато спроб. Спробуйте пізніше.',
        'Неправильна дата народження. Перевірте та спробуйте ще раз.',
        'Помилка перевірки безпеки. Оновіть сторінку та спробуйте ще раз.',
        'Помилка автентифікації. Спробуйте ще раз.',
        'Помилка з’єднання. Спробуйте ще раз.',
      ],
    },
  },
]
